import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';
import UserService from '@/services/UserService.js';

export default {
    methods: {
        async getLocations(restrict_by_user = 0) {
            UtilityService.getSimpleApiData(this.accessToken, "locations?printing=1&restrict_by_user=" + restrict_by_user).then(
                    response => this.locations = response 
                );
            },
        async getAllLocations() {
            UtilityService.getSimpleApiData(this.accessToken, "locations").then(
                    response => this.alllocations = response 
                );
            },
        async getPrintLocations(restrict_by_user = 0) {
            UtilityService.getSimpleApiData(this.accessToken, "locations?printing=1&include_factories=1&restrict_by_user=" + restrict_by_user).then(
                    response => this.locations = response 
                );
            },
        async getMakeupLocations(include_factories = 0) {
            UtilityService.getSimpleApiData(this.accessToken, "locations?makeup=1&include_factories=" + include_factories).then(
                    response => this.makeuplocations = response 
                );
        },
        async getOperations() {
            UtilityService.getSimpleApiData(this.accessToken, "operations").then(
                   response => this.operations = response 
                );
          },
        async getSizes() {
            UtilityService.getSimpleApiData(this.accessToken, "sizes").then(
                   response => this.sizes = response 
                );
          },
          async getSkuRanges() {
            UtilityService.getSimpleApiData(this.accessToken, "sku_ranges").then(
                   response => this.sku_ranges = response 
                );
          },
          async getStyles() {
            UtilityService.getSimpleApiData(this.accessToken, "styles").then(
                   response => this.styles = response 
                );
          },
        async getUserProfile(with_tasks, with_operations)
        {
            console.log("Loading User profile ")
            this.loading_user = true;
            UtilityService.getSimpleApiData(this.accessToken, "users/self?with_tasks=" + with_tasks + "&with_operations=" + with_operations).then(
                (response) => {
                    this.user = response 
                    this.loading_user = false
                    console.log("User profile loaded")
                }
            );
        },
        getMakeupUsers() {
            this.loading=true;
            UserService.getMakeupUsers(this.accessToken)
            .then(
                (users => {
                this.$set(this, "users", users);
                this.loading=false;
                
                }).bind(this)
            );
          },
        async updatePrintLocation(location_id) {
            this.working = true
    
            var order_id = this.order.orderID
    
            var formdata = { 
                _method: 'patch',
                 print_location_id: location_id,
                 
            }; 
    
            OrderService.updateOrder(this.accessToken, order_id, formdata)
            .then(() => {
                this.order.print_location_id = location_id
                
                //console.log(response)
                //alert("The print location for this order has been updated")
            }).catch((error) => {
               alert("Something went wrong and the order has not been updated. Please reload and try again")
                console.log("Error:" + JSON.stringify(error.response.data));
                
            }).finally(() => {
                this.working = false
            });
        },
        async updateFabricRollsLocation(location_id) {
            this.working = true
    
            var order_id = this.order.orderID
    
            var formdata = { 
                _method: 'patch',
                 fabric_print_location_id: location_id,
                 
            }; 
    
            OrderService.updateOrder(this.accessToken, order_id, formdata)
            .then(() => {
                this.order.fabric_print_location_id = location_id
                
                //console.log(response)
                //alert("The print location for this order has been updated")
            }).catch((error) => {
               alert("Something went wrong and the order has not been updated. Please reload and try again")
                console.log("Error:" + JSON.stringify(error.response.data));
                
            })
            .finally(() => {
                this.working = false
            });
        },
        async updateGerberCuttingLocation(location_id) {
            this.working = true
    
            var order_id = this.order.orderID
    
            var formdata = { 
                _method: 'patch',
                 gerber_print_location_id: location_id
            }; 
    
            OrderService.updateOrder(this.accessToken, order_id, formdata)
            .then(() => {
                this.order.gerber_print_location_id = location_id
                this.working = false
                //console.log(response)
                //alert("The print location for this order has been updated")
            }).catch((error) => {
               alert("Something went wrong and the order has not been updated. Please reload and try again")
                console.log("Error:" + JSON.stringify(error.response.data));
                this.working = false
            }).finally(() => {
                this.working = false
            });
        },
        updateSortOrder(sort_order)
        {
            if(this.loading == true)
                {
                    alert("Please wait for orders to load before re-sorting")
                }
                else {
                    this.orders = []
                    if(this.order_by === sort_order + " ASC")
                    {
                        this.order_by = sort_order + ' DESC'
                    }
                    else if(this.order_by === sort_order + " DESC")
                    {
                        this.order_by = null
                    }
                    else{
                        this.order_by = sort_order + ' ASC'
                    }

                    this.getOrders()
                }
        },
        padBundleZeros(bundle_id)
        {
            return ("0000000000" + bundle_id).slice(-11)
        },
        // Function to open a modal window
        openModal(modal, ponumber) {
            this.modalOrderPONumber = ponumber
            const $target = document.getElementById(modal);
            $target.classList.add('is-active');
        },
        closeModal($el) {
            $el.classList.remove('is-active');
        },
        closeAllModals() {
            (this.$el.querySelectorAll('.modal') || []).forEach(($modal) => {
              this.closeModal($modal);
            });
          },
          showSaveStatus(id)
        {
            if(id == 1)
            {
            return "Order Saved"
            }
            else if(id == 2)
            {
            return "Repeat Order"
            }
            else if(id == 3)
            {
            return "Order Saved before New System"
            }
            else{
            return "Unknown"
            }
        },
        displayClientLocationName(id)
        {
            if(id == 1)
            {
                return "ROI"
            }
            else if(id == 2)
            {
                return "N.Ireland"
            }
            else if(id == 3)
            {
                return "Great Britain"
            }
            else if(id == 4)
            {
                return "Export"
            }
            else{
                return "Unknown"
            }
        },
        task_allowed(task_id)
        {
            if(this.user?.tasks?.find(element => element == task_id) ) //|| this.user.userID == 170
            {
                return true;
            }
            else{
                return false;
            }
        },
        role_allowed(role_name)
        {
            if(this.user?.roles?.find(element => element == role_name) ) //|| this.user.userID == 170
            {
                return true;
            }
            else{
                return false;
            }
        },
        convertToUKDate(mysqlDate) {
            if (!mysqlDate) return '';
            
            const [year, month, day] = mysqlDate.split('-');
            if (!year || !month || !day) return '';
        
            return `${day}/${month}/${year}`;
          }
      
    },
    created() {
        
    },
    mounted() {
     
    },
    destroyed() {
      
    },
    computed: {
        selectedArea: function() {
            let areaName = "Unknown"

            if(this.area == "rolls")
            {
                areaName = "Transmatic Rolls"
            }
            else if(this.area == "paper")
            {
                areaName = "Digital Printing Paper"
            }
            else if(this.area == "cutting")
            {
                areaName = "Gerber Cutting"
            }
            else if(this.area == "multiply_cutting")
            {
                areaName = "Multi-Ply Gerber"
            }
            else if(this.area == "saving")
            {
                areaName = "Saving Digital Print"
            }
            else if(this.area == "cutsew_cutting")
            {
                areaName = "Cutting"
            }
            else if(this.area == "on_floor")
            {
                areaName = "On Floor"
            }
            else if(this.area == "off_floor")
            {
                areaName = "Off Floor"
            }
            else if(this.area == "embroidery")
            {
                areaName = "Embroidery"
            }
            else if(this.area == "silicon_stripes")
            {
                areaName = "Silicon Print"
            }


            return areaName
        },
        selectedLocation: function() {
            let locationName = "Unknown"

            if(this.makeup_input_location_id == 1)
            {
                locationName = "Strabane"
            }
            else if(this.makeup_input_location_id == 2)
            {
                locationName = "Giurgiu"
            }
            else if(this.makeup_input_location_id == 3)
            {
                locationName = "Dublin"
            }
            else if(this.makeup_input_location_id == 4)
            {
                locationName = "Derry"
            }


            return locationName
        },
        selectedMakeupArea: function() {
            let areaName = "Unknown"

            if(this.makeup_area == "on_factory_floor")
            {
                areaName = "On Floor"
            }
            else if(this.makeup_area == "off_factory_floor")
            {
                areaName = "Off Floor"
            }
            else if(this.makeup_area == "received")
            {
                areaName = "Receiving"
            }
            else if(this.makeup_area == "received_on_floor")
            {
                areaName = "Receive & On Floor"
            }
            else if(this.makeup_area == "clipping")
            {
                areaName = "Clipping"
            }
            else if(this.makeup_area == "packing")
            {
                areaName = "Packing"
            }
            else if(this.makeup_area == "warehouse")
            {
                areaName = "OWarehouse"
            }
            else if(this.makeup_area == "stock_take")
            {
                areaName = "Stock Take"
            }
            else if(this.makeup_area == "silicon_stripes")
            {
                areaName = "Stripes"
            }
            else if(this.makeup_area == "embossing")
            {
                areaName = "Embossing"
            }
            else if(this.makeup_area == "gps_pockets")
            {
                areaName = "GPS Pockets"
            }
            else if(this.makeup_area == "embroidery")
            {
                areaName = "Embroidery"
            }
            
            return areaName
        }
    }
  };